// extracted by mini-css-extract-plugin
export default {"item":"Item_item__RDsv7","anchor":"Item_anchor__TcRpY","title":"Item_title__CSNCs"};